module.exports = __webpack_public_path__ + "static/media/coding-tool-for-middleschool.387194e1.webp";